import { ChangeEventHandler, useState } from 'react'
import { Input } from '../../../Components/Form/Inputs'
import FormPage from '../../../Components/Form/Page/FormPage'
import useBriefContext from '../../../Hooks/Brief/useBriefContext'
import InputView from '../InputView'
import './EventNameInput.less'

const EventNameInput: InputView = ({path}) => {
  const {brief} = useBriefContext()
  const [eventName, setEventName] = useState( brief.eventName ?? '')
  const onChange: ChangeEventHandler<HTMLInputElement> = ({target}) => setEventName(target.value)

  return (
    <FormPage
      metaTitle={'Event name - HeadBox'}
      heading={'Give your event a name'}
      path={path}
      inputAttributes={{eventName}}
      className='name-page'
    >
      <label htmlFor='event-name' className='visually-hidden'>Event Name</label>
      <Input
        id='event-name'
        name='eventName'
        maxLength={50}
        type='text'
        onChange={onChange}
        required
        placeholder={`${brief.collectionName}...`}
        value={eventName}
      />
    </FormPage>
  )
}

export default EventNameInput
